import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Button } from '@zocdoc-frontend-common/components-button';
import LightweightDoctorCard from '@zocdoc-frontend-common/components-lightweight-doctor-card';
import { breakpoint } from '@zocdoc-frontend-common/styles-grid';
import { FontFamily } from '@zocdoc-frontend-common/styles-typography';
import {
    withCustomMetrics,
    EVENT_INITIATORS,
    INTERACTION_TYPES,
} from '@zocdoc-frontend-common/utils-frontend-metrics';
import { blue100, white } from '@zocdoc-mezzanine/foundations-colors';

const generateSearchLink = ({
    specialtyId,
    location,
    carrierId,
    planId,
    procedureId,
}) => {
    const { zipCode } = location || {};

    let url = `/search?filters=${encodeURIComponent(
        '{"is_virtual_location":["b64_b2ZmZXJzIHZpZGVvIHZpc2l0cw=="]}'
    )}`;

    url += `&dr_specialty=${specialtyId}`;
    url += `&insurance_carrier=${carrierId}`;
    url += `&insurance_plan=${planId}`;
    url += `&reason_visit=${procedureId}`;
    url += `&address=${zipCode}`;
    return url;
};

export const VirtualVisitSearchResults = (props) => {
    const { providerLocations, sendMetric } = props;

    useEffect(() => {
        if (providerLocations) {
            sendMetric({
                initiator: EVENT_INITIATORS.USER,
                interactionType: INTERACTION_TYPES.VIEW,
                label: providerLocations.length,
            });
        }
    }, [sendMetric, providerLocations]);

    if (providerLocations && providerLocations.length > 0) {
        const numResults = providerLocations.length;
        return (
            <Wrapper>
                <Header numResults={numResults}>
                    Many providers on Zocdoc offer video visits, so you can get
                    the care you need without leaving home.
                </Header>
                <div>
                    <CardWrapper data-test="virtual-visit-search-results">
                        {providerLocations.map((providerResult, idx) => (
                            <StyledCard
                                index={idx}
                                key={idx}
                                numResults={numResults}
                                {...providerResult}
                            />
                        ))}
                    </CardWrapper>
                    <ButtonWrapper>
                        <StyledButton
                            href={generateSearchLink(props)}
                            data-test="search-more-button"
                        >
                            Search for video visits
                        </StyledButton>
                    </ButtonWrapper>
                </div>
            </Wrapper>
        );
    }

    return null;
};

export default withCustomMetrics({
    element: 'Screener Failure Similar Doctor Section',
})(VirtualVisitSearchResults);

const Wrapper = styled.div`
    padding: 0 15px;

    ${breakpoint.small} {
        padding: 0;
    }
`;

const CardWrapper = styled.div`
    margin: 13px auto 20px;
    max-width: 1300px;

    ${breakpoint.small} {
        display: flex;
        justify-content: center;
    }
`;

const Header = styled.p`
    font: 16px/24px ${FontFamily.SharpSansBold};
    text-align: center;
    margin: auto;
    max-width: ${(p) => (p.numResults === 1 ? '700px' : 'initial')};
`;

const ButtonWrapper = styled.div`
    text-align: center;
    margin-bottom: 45px;
`;

const StyledButton = styled(Button)`
    background: transparent;
    border-color: ${blue100};
    font-size: 15px;
    width: 100%;
    max-width: 416px;
    box-sizing: border-box;

    :hover {
        color: ${blue100};
        background: transparent;
    }
`;

export const StyledCard = styled(LightweightDoctorCard)`
    margin-bottom: 16px;
    background: ${white};
    display: block;
    ${breakpoint.small} {
        margin: 0 8px;
        flex: 1;
        max-width: ${(p) => (p.numResults === 1 ? '460px' : 'initial')};
    }
`;
